<template>
  <v-breadcrumbs
    :items="breadcrumbItems"
    divider=">"
    class="pa-0 ml-4 large-breadcrumbs"
  >
    <template v-slot:item="{ item }">
      <v-breadcrumbs-item
        :disabled="item.disabled"
        @click="!item.disabled && navigateTo(item.path)"
        class="breadcrumb-item text-h5"
        :class="{ 'current-item': item.disabled }"
        style="font-size: 1.5rem !important"
      >
        <v-icon left size="28" v-if="item.icon">{{ item.icon }}</v-icon>
        <span style="font-size: 1.5rem !important; font-weight: 500">{{
          item.text
        }}</span>
      </v-breadcrumbs-item>
    </template>
  </v-breadcrumbs>
</template>

<script>
import { mapState, mapMutations } from "vuex";

export default {
  name: "LayoutBreadcrumb",

  computed: {
    ...mapState("admin", ["currentLayout", "editingPath", "availableProducts"]),

    breadcrumbItems() {
      const items = [
        {
          text: this.currentLayout.LayoutName || "Root Layout",
          icon: "mdi-view-dashboard",
          path: [],
          disabled: this.editingPath.length === 0,
        },
      ];

      let currentObjects = this.currentLayout.Objects;
      let currentPath = [];

      // Build breadcrumb from editing path
      for (let i = 0; i < this.editingPath.length; i++) {
        const index = this.editingPath[i];
        currentPath.push(index);

        if (currentObjects && currentObjects[index]) {
          const item = currentObjects[index];
          const itemName = this.getItemDisplayName(item, index);

          items.push({
            text: itemName,
            icon: this.getItemIcon(item),
            path: [...currentPath],
            disabled: i === this.editingPath.length - 1, // Current level is disabled
          });

          // Move deeper into the structure
          if (item.Objects) {
            currentObjects = item.Objects;
          }
        }
      }

      return items;
    },
  },

  methods: {
    ...mapMutations("admin", ["navigateToPath"]),

    navigateTo(path) {
      this.navigateToPath(path);
      this.$emit("navigate", path);
    },

    getItemDisplayName(item, index) {
      if (item.itemType === "Group") {
        return item.GroupName || `Group ${index + 1}`;
      } else if (item.itemType === "Product") {
        // Handle ProductId format
        if (item.ProductId?.ProductId) {
          const product = this.availableProducts.find(
            (p) => p.ProductId === item.ProductId.ProductId
          );
          return product?.ProductName || product?.ShortName || "Product";
        }
        // Fallback for old ProductId format (migration support)
        if (item.ProductId) {
          return (
            item.ProductId.ProductName || item.ProductId.ShortName || "Product"
          );
        }
        return `Product ${index + 1}`;
      }
      return `Item ${index + 1}`;
    },

    getItemIcon(item) {
      if (item.itemType === "Group") {
        return item.GroupType === "Selection" ? "mdi-view-list" : "mdi-folder";
      } else if (item.itemType === "Product") {
        return "mdi-package-variant";
      }
      return "mdi-circle-outline";
    },
  },
};
</script>

<style scoped>
.breadcrumb-item {
  cursor: pointer;
  transition: all 0.2s ease;
}

.breadcrumb-item:hover:not(.current-item) {
  background-color: rgba(25, 118, 210, 0.1);
  border-radius: 4px;
}

.current-item {
  font-weight: 600;
  color: var(--v-primary-base) !important;
}

.v-breadcrumbs {
  padding: 12px 20px;
  background-color: rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  margin-bottom: 20px;
  margin-left: 16px;
}

.breadcrumb-item {
  font-size: 1.5rem !important;
  padding: 8px 12px;
}

.breadcrumb-item .v-breadcrumbs__item {
  font-size: 1.5rem !important;
}

.v-breadcrumbs .v-breadcrumbs__item {
  font-size: 1.5rem !important;
}

.v-breadcrumbs__item {
  font-size: 1.5rem !important;
  font-weight: 500 !important;
}
</style>
